import { dochubInstance } from '../instance';
import { authHeaders } from '../tokens';

export type TFetchCurrentUserResponse = {
  data: {
    id: string;
    attributes: {
      email: string;
      name: string;
      uploadFileName: string | null;
      uploadUpdatedAt: string | null;
    };
  };
  included?: {
    type: string;
    relationships?: {
      proSubscriptions?: {
        data?: {
          id: string;
        }[];
      };
    };
  }[];
};

export default {
  getCurrentUser: (): Promise<TFetchCurrentUserResponse> =>
    dochubInstance.get('v2/users/current-user', { headers: authHeaders() }),
};
